module.exports = __webpack_public_path__ + "static/media/family.a20b6540.JPG";